import React, { Component } from 'react';
 
class VoiceButton extends Component {

  handleClick = () => {
    const synth = window.speechSynthesis;
    const Utterance = new SpeechSynthesisUtterance("妈妈，我想吃饭。今天能吃小熊要吗？");
    Utterance.text = this.props.text ? this.props.text : "The content of this speech is not available";
    Utterance.lang = this.props.lang ? this.props.lang : "en-US";
    Utterance.rate = this.props.rate ? this.props.rate : 0.75;
    Utterance.pitch = this.props.pitch ? this.props.pitch : 1;
    synth.speak(Utterance);
  }

  render () {
    return <i className="fas fa-volume-up" onClick={this.handleClick}> {this.props.displayedChars}</i>
  }

  static defaultProps = {
    displayedChars: ""
  }
}

export default VoiceButton;